export function isDevelopmentEnvironment(): boolean {
  return import.meta.env.VITE_APP_ENVIRONMENT === 'dev';
}